<div class="layout-container" [ngClass]="containerClass()">
    <p-toast position="top-right"
        [breakpoints]="{'620px': {width: '100%', right: '0', left: '0', top: '0'}}"
        life="6000">
    </p-toast>

    <app-confirm-dialog></app-confirm-dialog>
    
    <div app-topbar></div>
    <div app-right-menu></div>
    <div app-sidebar></div>
    <div class="layout-content-wrapper">
        <div app-breadcrumb></div>
        <div class="layout-content">
            <router-outlet></router-outlet>
        </div>
        <div app-footer></div>
    </div>
</div>
<app-configurator />
<app-loading></app-loading>
